import { render, staticRenderFns } from "./MyReview.vue?vue&type=template&id=659cb429"
import script from "./MyReview.vue?vue&type=script&lang=js"
export * from "./MyReview.vue?vue&type=script&lang=js"
import style0 from "./MyReview.vue?vue&type=style&index=0&id=659cb429&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports